// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__4ZGHD","control":"Auth_control__0ubxT"};